module.exports = __webpack_public_path__ + "fonts/sourcesansprolightitalic.4b93cf66.woff";